import { render, staticRenderFns } from "./title-content.vue?vue&type=template&id=24c0a2d6&"
import script from "./title-content.vue?vue&type=script&lang=ts&"
export * from "./title-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c0a2d6')) {
      api.createRecord('24c0a2d6', component.options)
    } else {
      api.reload('24c0a2d6', component.options)
    }
    module.hot.accept("./title-content.vue?vue&type=template&id=24c0a2d6&", function () {
      api.rerender('24c0a2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/title/title-content.vue"
export default component.exports